module.exports = __webpack_public_path__ + "static/media/info.28a548d2.svg";